import { useFormikContext } from 'formik';
import TextField from '../forms/text-field';
import type { EventFormValues } from './form';

const EventFormRouteUrl = (props) => {
  const { values: { eventType } } = useFormikContext<EventFormValues>();

  if (eventType !== 'RIDE') {
    return null;
  }

  return (
    <TextField
      name="routeUrl"
      label="Route URL (optional)"
      helperText="Ride With GPS routes will be automatically embedded"
      {...props}
    />
  );
};

export default EventFormRouteUrl;
